module.exports = __webpack_public_path__ + "media/markers/marker-cluster-yellow-4f9ac829.svg";